module.exports = __webpack_public_path__ + "images/emoji/cocktail.f35961af9c0b56d86442.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cocktail.png
// module id = Wm/K
// module chunks = 1